module.exports = __webpack_public_path__ + "img/jxhy_logo.0dffb5ae.png";